import {AccountBean, FilterListBean, ListResponseFilterListBean} from 'common/api/api';
import {getFilterListTypeName} from 'common/api/dictionaries'
import {filterListApi} from 'common/api/entitiesApi'
import {FilterListTypeSelector} from 'common/components/dictionary/FilterListTypeSelector'
import {OwnedBySelector} from 'common/components/dictionary/OwnedBySelector'
import {ListCard} from 'common/components/ListCard'
import {AdvertiserSelector} from 'common/components/reloadable/AdvertiserSelector'
import {SearchInput} from 'common/components/SearchInput'
import {ListFilters, useAppContext} from 'common/context/AppContext'
import {CommonRoutes} from 'common/context/commonRoutes'
import {COLUMN_ID_WIDTH, COLUMN_NAME_WIDTH} from 'common/util/constants'
import {initListFilters, useListFilters} from 'common/util/useListFilters'
import {apiCall} from 'common/util/Util'
import {useState} from 'react';
import {Link} from 'react-router-dom'
import RoleEnum = AccountBean.RoleEnum
import dayjs from 'dayjs'
import { Tag } from 'antd'

const FilterListList = ({agency}) => {
    const appContext = useAppContext()
    const [loading, setLoading] = useState(false)
    const initialFilters = {} as ListFilters
    // const initialFilters = {ownedBy: admin ? 'SuperAdmin' : agency ? 'Admin' : 'Advertiser'} as ListFilters
    const [filters, setFilters] = useState<ListFilters>(initListFilters(initialFilters))
    const {setFilter} = useListFilters(setFilters)
    const [listData, setListData] = useState<ListResponseFilterListBean>()


    const loadData = () => {
        apiCall(setLoading, appContext,
            () => filterListApi.getPageFilterLists(
                filters.sort?.name,
                filters.sort?.direction,
                filters.name,
                filters.type,
                filters.advertiserId,
                filters.ownedBy,
                {query: {page: filters.page, size: filters.pageSize}}
            ),
            (response) => setListData(response)
        )
    };

    return (
        <ListCard loading={loading} title="Filter Lists"
                  createName="Filter List" createRoute={CommonRoutes.FILTER_LIST_CREATE}
                  listRouteKey={CommonRoutes.FILTER_LIST}
                  filters={filters} setFilters={setFilters} initialFilters={initialFilters}
                  listData={listData} loadData={loadData}
                  columns={[
                      {
                          title: "ID",
                          dataIndex: "id",
                          width: COLUMN_ID_WIDTH,
                          fixed: 'left'
                      },
                      {
                          title: "Name",
                          dataIndex: "name",
                          className: "list-table-name",
                          sorter: true,
                          ellipsis: true,
                          render: (text, record) => (<Link style={{color: '#5888CF', minWidth: 100}}
                                                           to={`${CommonRoutes.FILTER_LIST}/${record.id}/edit`}>{text}</Link>),
                          width: COLUMN_NAME_WIDTH,
                          fixed: 'left'
                      },
                          // ...((admin) ? [{
                          // title: "Agency",
                          // dataIndex: "agencyName",
                          // ellipsis: true,
                          // width: 160
                          // }] : []),
                          ...((agency) ? [{
                          title: "Advertiser",
                          dataIndex: "advertiserName",
                          ellipsis: true,
                          width: 160
                      }] : []),
                      {
                          title: "Type",
                          dataIndex: "type",
                          render: (value) => getFilterListTypeName(value),
                          sorter: true,
                          width: 160
                      },
                      {
                          title: 'Status',
                          dataIndex: 'processed',
                          width: 80,
                          render: (_, record: FilterListBean) => (
                              <Tag color={record.processed ? 'green' : '#E6E6E6'} style={{color: '#0D1A43', textAlign: 'center'}}>
                                {record.processed ? 'Processed' : 'Pending'}
                              </Tag>
                          )
                      },
                      {
                          title: "Last Modified",
                          dataIndex: "modified",
                          sorter: true,
                          width: 150,
                          render: (date) => date && dayjs(date).format('DD MMM YYYY')
                      }
                  ]}
        >
            <SearchInput value={filters.name} onChange={(value) => setFilter('name', value)}/>
            <FilterListTypeSelector placeholder="Filter by Type"
                                    style={{minWidth: '180px'}}
                                    value={filters.type}
                                    onChange={(value) => setFilter('type', value)}
            />
            {(agency) && (<>
                    <OwnedBySelector placeholder="Filter by Owner"
                                     style={{minWidth: '160px'}}
                                     value={filters.ownedBy}
                                     onChange={(value) => setFilter('ownedBy', value)}
                    />
                    <AdvertiserSelector
                        disabled={filters.ownedBy != RoleEnum.Advertiser.toString()}
                        placeholder="Filter by Advertiser"
                        style={{minWidth: '200px'}}
                        value={filters.advertiserId}
                        onChange={(value: number) => setFilter('advertiserId', value)}
                    /></>
            )}
        </ListCard>
    )
}

export default FilterListList
